import(/* webpackMode: "eager" */ "/codebuild/output/src3297588696/src/octohealth-web/app/blog/[slug]/page.tsx");
